/** Set by Playwright E2E via `spa/e2e/utils/automationOverlayInit.ts` context init script. */
export const E2E_SUPPRESS_OVERLAYS_KEY = 'OPENSOLAR_E2E_SUPPRESS_OVERLAYS'

/** When true, IAP promos, FUJI tour chrome, and optional version-update dialogs stay hidden. */
export function shouldSuppressE2eOverlays(): boolean {
  if (typeof localStorage === 'undefined') return false
  try {
    return localStorage.getItem(E2E_SUPPRESS_OVERLAYS_KEY) === '1'
  } catch {
    return false
  }
}
